import { VehicleOrganizationModel } from "./vehicle-organization.model";

export class VehicleModel {
  id?: number;
  externalId?: number;
  category?: string;
  licencePlate?: string;
  enabled?: boolean;
  vehicleOrganizations?: VehicleOrganizationModel[];
  createdByUsername?: string;
  createdDate?: any;
  updatedByUsername?: string;
  updatedDate?: any;

  constructor(options: VehicleModel = {}) {
    this.id = options.id || null;
    this.externalId = options.externalId || null;
    this.category = options.category || null;
    this.licencePlate = options.licencePlate || null;
    this.enabled = options.enabled || null;
    this.vehicleOrganizations = options.vehicleOrganizations || null;
    this.createdByUsername = options.createdByUsername || null;
    this.createdDate = options.createdDate || null;
    this.updatedByUsername = options.updatedByUsername || null;
    this.updatedDate = options.updatedDate || null;
  }
}
